/* WeBitchin' — Animation Layer */
(function() {
  'use strict';

  /* —— CUSTOM CURSOR —— */
  var cursor = document.createElement('div');
  cursor.id = 'wb-cursor';
  cursor.style.cssText = 'position:fixed;top:0;left:0;width:12px;height:12px;background:#FF2D9B;border-radius:50%;pointer-events:none;z-index:99999;transform:translate(-50%,-50%);transition:transform 0.08s ease,opacity 0.2s;mix-blend-mode:screen;';
  var cursorRing = document.createElement('div');
  cursorRing.id = 'wb-cursor-ring';
  cursorRing.style.cssText = 'position:fixed;top:0;left:0;width:32px;height:32px;border:1px solid rgba(255,45,155,0.45);border-radius:50%;pointer-events:none;z-index:99998;transform:translate(-50%,-50%);transition:left 0.22s ease,top 0.22s ease,width 0.2s,height 0.2s,border-color 0.2s;';
  document.body.appendChild(cursor);
  document.body.appendChild(cursorRing);

  var mx = window.innerWidth / 2, my = window.innerHeight / 2;
  var rx = mx, ry = my;

  document.addEventListener('mousemove', function(e) {
    mx = e.clientX; my = e.clientY;
    cursor.style.left = mx + 'px';
    cursor.style.top  = my + 'px';
  });

  function animRing() {
    rx += (mx - rx) * 0.12;
    ry += (my - ry) * 0.12;
    cursorRing.style.left = rx + 'px';
    cursorRing.style.top  = ry + 'px';
    requestAnimationFrame(animRing);
  }
  animRing();

  document.addEventListener('mousedown', function() {
    cursor.style.transform = 'translate(-50%,-50%) scale(0.6)';
    cursorRing.style.width  = '48px';
    cursorRing.style.height = '48px';
    cursorRing.style.borderColor = 'rgba(255,45,155,0.8)';
  });
  document.addEventListener('mouseup', function() {
    cursor.style.transform = 'translate(-50%,-50%) scale(1)';
    cursorRing.style.width  = '32px';
    cursorRing.style.height = '32px';
    cursorRing.style.borderColor = 'rgba(255,45,155,0.45)';
  });

  /* —— SCROLL REVEAL —— */
  var revealEls = document.querySelectorAll('.wb-lore, .wb-stats, .wb-characters, .wb-card, .wb-product-header, .shopify-section:not(.wb-hero-section):not(.wb-ticker-section)');
  revealEls.forEach(function(el) {
    el.style.opacity   = '0';
    el.style.transform = 'translateY(28px)';
    el.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
  });

  var revealObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity   = '1';
        entry.target.style.transform = 'translateY(0)';
        revealObs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  revealEls.forEach(function(el) { revealObs.observe(el); });

  /* character cards stagger */
  document.querySelectorAll('.wb-card').forEach(function(card, i) {
    card.style.transitionDelay = (i * 0.12) + 's';
  });

  /* —— STAT COUNTER —— */
  function animCount(el, target, duration) {
    var start = null;
    var num   = parseInt(target, 10);
    var suffix = el.dataset.suffix || '';
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var ease = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.floor(num * ease) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = target + suffix;
    }
    requestAnimationFrame(step);
  }

  var statsEl = document.querySelector('.wb-stats');
  if (statsEl) {
    var statObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var vals     = entry.target.querySelectorAll('.wb-stat-val');
        var targets  = ['100', '300', '001', '6'];
        var suffixes = ['',    '+',   '',    ''];
        vals.forEach(function(v, i) {
          v.dataset.suffix = suffixes[i];
          animCount(v, targets[i], 1400);
        });
        statObs.unobserve(entry.target);
      });
    }, { threshold: 0.5 });
    statObs.observe(statsEl);
  }

  /* —— TICKER SPEED —— */
  var ticker = document.querySelector('.wb-ticker-track');
  if (ticker) {
    ticker.parentElement.addEventListener('mouseenter', function() { ticker.style.animationDuration = '16s'; });
    ticker.parentElement.addEventListener('mouseleave', function() { ticker.style.animationDuration = '35s'; });
  }

  /* —— HERO ENTRANCE then NEON FLICKER —— */
  var heroBadge = document.querySelector('.wb-drop-badge');
  var heroSub   = document.querySelector('.wb-hero-sub');
  var heroLogo  = document.querySelector('.wb-hero-wordmark');
  var ENTRANCE_DURATION = 700; /* ms for opacity transition */

  [heroBadge, heroSub, heroLogo].forEach(function(el, i) {
    if (!el) return;
    el.style.opacity    = '0';
    el.style.transform  = 'translateY(16px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    var delay = 200 + i * 180;
    setTimeout(function() {
      el.style.opacity   = '1';
      el.style.transform = 'translateY(0)';
    }, delay);
  });

  /* After entrance fully completes: clear inline styles, hand off to CSS flicker */
  if (heroLogo) {
    var flickerStart = 200 + 2 * 180 + ENTRANCE_DURATION + 200; /* badge delay + logo offset + transition + buffer */
    setTimeout(function() {
      heroLogo.style.opacity    = '';
      heroLogo.style.transform  = '';
      heroLogo.style.transition = '';
      heroLogo.classList.add('wb-neon-active');
    }, flickerStart);
  }

  /* —— CHARACTER CARD GLOW —— */
  var trissCard  = document.querySelector('.wb-card--triss');
  var stonksCard = document.querySelector('.wb-card--stonks');

  if (trissCard) {
    var ti = trissCard.querySelector('.wb-card-img');
    trissCard.addEventListener('mouseenter', function() {
      if (ti) ti.style.filter = 'drop-shadow(0 0 40px rgba(255,45,155,0.7))';
      trissCard.style.transform = 'translateY(-4px)';
    });
    trissCard.addEventListener('mouseleave', function() {
      if (ti) ti.style.filter = 'drop-shadow(0 0 24px rgba(255,45,155,0.35))';
      trissCard.style.transform = 'translateY(0)';
    });
  }

  if (stonksCard) {
    var si = stonksCard.querySelector('.wb-card-img');
    stonksCard.addEventListener('mouseenter', function() {
      if (si) si.style.filter = 'drop-shadow(0 0 40px rgba(123,47,190,0.75))';
      stonksCard.style.transform = 'translateY(-4px)';
    });
    stonksCard.addEventListener('mouseleave', function() {
      if (si) si.style.filter = 'drop-shadow(0 0 24px rgba(123,47,190,0.4))';
      stonksCard.style.transform = 'translateY(0)';
    });
  }

  /* —— PRODUCT CARD GLOW —— */
  document.querySelectorAll('[class*="product-card"], .card').forEach(function(card) {
    card.style.transition = 'box-shadow 0.25s ease, transform 0.25s ease';
    card.addEventListener('mouseenter', function() {
      card.style.boxShadow = '0 0 0 1px rgba(255,45,155,0.35), 0 8px 32px rgba(255,45,155,0.12)';
      card.style.transform = 'translateY(-3px)';
    });
    card.addEventListener('mouseleave', function() {
      card.style.boxShadow = 'none';
      card.style.transform = 'translateY(0)';
    });
  });

})();
